export default "__VITE_PUBLIC_ASSET__55d06d29__"